<template>
  <div id="rekomendasi">
    <v-toolbar light style="background:white; box-shadow:2px 0px 4px 0px lightgray;">
      <v-btn small icon dark @click="$router.go(-1)">
      <v-icon style="color:#10aa85;">arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title style="color:#10aa85;" v-if="major.univ">{{major.univ}}</v-toolbar-title>
      <v-toolbar-title style="color:#10aa85;" v-if="major.university">{{major.university}}</v-toolbar-title>
    </v-toolbar>
    <v-container fluid >
      <!-- <v-divider></v-divider> -->
      <v-layout row wrap v-if="JSON.stringify(recommendation) === '[]'">
        <v-flex xs12>
          <div class="no-prodi">
            <img src="@/assets/icon/no_prodi.svg" alt="image-alt"/>
            <p>
              Maaf, Data rekomendasi belum tersedia
            </p>
          </div>
        </v-flex>
      </v-layout>
      <v-card hover style="margin-bottom: 0px; border-radius:8px;">
      <v-layout row wrap>
        <v-flex xs12 v-for="(item, index) in recommendation" v-bind:key="index">
            <v-container fluid>
              <v-layout>
                <v-flex xs10>
                  <h3>{{item.name}}</h3>
                  <p v-if="item.univ" style="margin-bottom:0px;">{{item.univ}}</p>
                  <p v-if="item.university" style="margin-bottom:0px;">{{item.university}}</p>
                </v-flex>
              </v-layout>
            </v-container>
        <v-divider></v-divider>
        </v-flex>
      </v-layout>
      </v-card>
      <!-- <v-list subheader v-if="JSON.stringify(recommendation) !== '[]'">
          <v-list-tile
            v-for="(item, index) in recommendation" v-bind:key="index"
            avatar
          >
            <v-list-tile-content>
              <v-list-tile-title v-html="item.name"></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list> -->
    </v-container>
  </div>
</template>
<style>
.no-prodi {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  min-height: 100vh;
}
</style>

<script>
export default {
  name: 'rekomendasi-univ-list',
  data: function () {
    return {
      major: null,
      recommendation: []
    }
  },
  beforeMount: function () {
    var groupId = parseInt(this.$route.params.id)
    var sequence = parseInt(this.$route.params.sid)
    var score = JSON.parse(sessionStorage.getItem('score_' + groupId))
    var majorStatus = score.prodis
    // var majorStatus = score.majorStatus
    var context = this
    var rekomendasi = majorStatus.find(function (g) {
      return g.sequence === sequence
    })
    // console.log(rekomendasi)
    context.major = rekomendasi

    context.recommendation = rekomendasi.recommendation
    context.recommendation = rekomendasi.univ_recommendations
  },
  mounted: function () {
    // var groupId = this.$route.params.id
    // var sequence = this.$route.params.sequence
  }
}
</script>
